import { DateTime } from 'luxon'

export default function time(str) {
  const datetime = DateTime.fromISO(str)

  return datetime.setZone('America/New_York').toLocaleString(DateTime.TIME_SIMPLE)
}
